// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"730ad153","103":"5294b90c","166":"d31c037b","182":"4161c7d7","533":"64135eb5","840":"cb06fcf1","907":"6905ea93","909":"afd4176f","959":"914662ab","967":"07678826"}[chunkId] + ".chunk.js";
};